﻿// Start the main app logic.
define(['languageControl', 'toolbarControl', 'mixpanelControl'],
		
		function () {
				'use strict';
		}
);